import * as constants from 'redux/constants/app.constants';

export const initializeApp = () => ({
  type: constants.APP_INITIALIZE_REQUESTED,
});

export const initializeHome = () => ({
  type: constants.APP_HOME_REQUESTED,
});
